import axios from 'axios';
import { postMethod, postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const REGISTER_PROFESSIONAL = 'REGISTER_PROFESSIONAL';
export const REGISTER_PROFESSIONAL_SUCCESS = 'REGISTER_PROFESSIONAL_SUCCESS';
export const REGISTER_PROFESSIONAL_FAILURE = 'REGISTER_PROFESSIONAL_FAILURE';

// Action Creators
export const registerProfessionalRequest = () => ({
  type: REGISTER_PROFESSIONAL,
});

export const registerProfessionalSuccess = (users) => ({
  type: REGISTER_PROFESSIONAL_SUCCESS,
  payload: users,
});

export const registerProfessionalFailure = (error) => ({
  type: REGISTER_PROFESSIONAL_FAILURE,
  payload: error,
});

// Thunk Function

export const registerProfessionalPost = (
  body,
  userId,
  external,
  token = true
) => {
  return async (dispatch) => {
    dispatch(registerProfessionalRequest());
    try {
      const response = token
        ? await postMethodWithToken(url.postProfessional + userId + '/', body)
        : await postMethod(url.postProfessional + userId + '/', body);
      if (external?.run === true) {
        if (
          response?.data?.status_code === 200 ||
          response?.data?.status_code === 201
        ) {
          external?.handleFunction(response?.data);
          dispatch(registerProfessionalSuccess(response));
        } else {
          if (external?.error === true) {
            external?.handleErrorFunction(response?.data);
          }
          dispatch(registerProfessionalFailure('error'));
        }
      }
    } catch (error) {
      dispatch(registerProfessionalFailure(error));
      if (external?.error === true) {
        external?.handleErrorFunction(error);
      }
    }
  };
};
